<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-0 px-4 layout row wrap">
          <h3>{{$lang.header.autoJobs}}</h3>
          <v-checkbox
            color="primary"
            class="ml-3 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
           />
          <v-spacer />
          <v-text-field
            class="min-w max-w"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="showActive ? activeAutojobs : allAutojobs"
          :search="search"
          :loading="allAutojobs.length === 0"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.jobName }}</td>
            <td class="min-w">{{ props.item.jobDesc }}</td>
            <td>{{ formatDate(props.item.lastExecutedOn) }}</td>
            <td>{{ formatDate(props.item.nextPlannedExecutionOn) }}</td>
            <td>{{ props.item.status }}</td>
            <td>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        err: '',
        search: '',
        headers: [
          {text: this.$lang.header.jobName, value: 'jobName', align: 'left',},
          {text: this.$lang.header.jobDesc, value: 'jobDesc', align: 'left',},
          {text: this.$lang.header.lastExec, value: 'lastExecutedOn', align: 'left',},
          {text: this.$lang.header.nextExec, value: 'nextPlannedExecutionOn', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        showActive: true,
        allAutojobs: [],
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      changeStatus(autojob) {
        const action = autojob.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`autojobswitch/${action}/${autojob.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(autojob, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      activeAutojobs() {
        const autojobs = this.allAutojobs;
        const activeAutojobs = [];
        for (let i=0; autojobs.length > i; i++) {
          if (autojobs[i].status === 'active') {
            activeAutojobs.push(autojobs[i]);
          }
        }
        return activeAutojobs;
      },
    },
    created() {
      this.$http.get('autojobswitch/getall')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allAutojobs = res.body.autoJobs;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    }
  };
</script>



// WEBPACK FOOTER //
// AutoJob.vue?3dc843c0